import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowCircleLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M20 36c-8.839 0-16-7.161-16-16S11.161 4 20 4s16 7.161 16 16-7.161 16-16 16Zm1.864-9.265-4.87-4.67h11.78c.858 0 1.549-.69 1.549-1.549v-1.032c0-.858-.69-1.549-1.549-1.549h-11.78l4.87-4.67c.626-.6.64-1.6.026-2.213l-.71-.704a1.542 1.542 0 0 0-2.186 0l-8.562 8.555a1.542 1.542 0 0 0 0 2.187l8.562 8.568a1.542 1.542 0 0 0 2.187 0l.71-.703c.612-.62.6-1.62-.026-2.22Z" })
});
export default SvgArrowCircleLeft;
